export type ClipboardImagesResult = { kind: 'images'; files: File[] } | { kind: 'empty'; files: [] }

export function getClipboardImages(data: DataTransfer | ClipboardEvent['clipboardData'] | null, now = new Date()): ClipboardImagesResult {
  if (!data) return {kind:'empty',files:[]}
  const images: File[] = []
  let index = 0
  for (const item of Array.from(data.items ?? [])) {
    if (item.kind !== 'file' || !item.type.toLowerCase().startsWith('image/')) continue
    const file = item.getAsFile()
    if (!file) continue
    index += 1
    const ext = file.type.toLowerCase() === 'image/jpeg' ? 'jpg' : (file.type.split('/')[1]?.replace('jpeg','jpg') || 'png')
    const stamp = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}-${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}${String(now.getSeconds()).padStart(2,'0')}`
    images.push(new File([file], `Ảnh dán ${stamp}-${index}.${ext}`, {type:file.type,lastModified:file.lastModified}))
  }
  return images.length ? {kind:'images',files:images} : {kind:'empty',files:[]}
}

export function handleClipboardImages(
  data: DataTransfer | ClipboardEvent['clipboardData'] | null,
  preventDefault: () => void,
  addFiles: (files: File[]) => void,
  showEmptyNotice: () => void,
): ClipboardImagesResult {
  const result = getClipboardImages(data)
  if (result.kind === 'images') {
    preventDefault()
    addFiles(result.files)
  } else {
    showEmptyNotice()
  }
  return result
}
